import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import WolfMark from "@/components/WolfMark";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    const res = await register(name.trim(), email.trim(), password);
    setBusy(false);
    if (res.ok) nav("/den", { replace: true });
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080808] px-6 pt-28 pb-16" data-testid="register-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-10">
          <WolfMark className="w-10 h-10" />
          <p className="font-display tracking-extreme text-white text-2xl">WOLF</p>
        </div>
        <p className="text-[11px] uppercase tracking-[0.32em] text-[#D4AF37]/90">— Join The Pack</p>
        <h1 className="font-display text-5xl sm:text-6xl text-white mt-3 leading-[0.9]">Take your seat.</h1>
        <p className="font-editorial italic text-white/55 mt-3">No noise. No performance. Just the floor.</p>

        <form onSubmit={submit} className="mt-10 space-y-4" data-testid="register-form">
          <div>
            <label className="text-[10px] uppercase tracking-[0.32em] text-white/60">Name</label>
            <input
              data-testid="register-name-input"
              type="text"
              required
              minLength={1}
              maxLength={60}
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-2 w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition"
              placeholder="How they call you"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.32em] text-white/60">Email</label>
            <input
              data-testid="register-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition"
              placeholder="you@wolf.com"
            />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-[0.32em] text-white/60">Password</label>
            <input
              data-testid="register-password-input"
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 w-full bg-transparent border border-white/15 px-4 py-3 text-white placeholder-white/30 focus:outline-none focus:border-[#D4AF37] transition"
              placeholder="6+ characters"
            />
          </div>

          {err && <p className="text-sm text-red-300" data-testid="register-error">{err}</p>}

          <button
            type="submit"
            disabled={busy}
            data-testid="register-submit-btn"
            className="w-full font-display tracking-extreme text-sm bg-transparent text-[#D4AF37] border border-[#D4AF37]/70 px-6 py-4 hover:bg-[#D4AF37] hover:text-black hover:border-[#D4AF37] transition-colors disabled:opacity-40"
          >
            {busy ? "Tracking…" : "Run With Us"}
          </button>
        </form>

        <p className="mt-8 text-[11px] uppercase tracking-[0.28em] text-white/55">
          Already in?{" "}
          <Link to="/login" data-testid="register-login-link" className="text-white hover:text-[#D4AF37] underline underline-offset-4">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
